/** App-wide layout breakpoint: phone column below, list+detail at this width. */
export const WIDE_LAYOUT_MQ = '(min-width: 720px)';

export function isWideLayout(): boolean {
  return window.matchMedia(WIDE_LAYOUT_MQ).matches;
}

export function subscribeWideLayout(onChange: () => void): () => void {
  const mq = window.matchMedia(WIDE_LAYOUT_MQ);
  const handler = () => onChange();
  mq.addEventListener('change', handler);
  return () => mq.removeEventListener('change', handler);
}
